import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import CustomDialog from "./CustomDialog";
import ToolTip from "./ToolTip";
import usePermission from "../../usePermission";
import { Typography } from "@mui/material";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import CustomerContext from "../../context/customer/CustomerContext";
import SvgIcon from "@mui/material/SvgIcon";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";
export default function Toolbox(props: {
  isLoading: boolean;
  displayFilter: () => void;
  editClient: () => void;
  deleteClient: () => void;
  displayComments: () => void;
  displayOrganizationalStructure: () => void;
  displayClientFiling: () => void;
  displayClientCategories: () => void;
  displayAddClientFiling: () => void;
  displayHistory: () => void;
  selectedClients: any;
  postAward: any;
}) {
  const OrganizationTreeIcon = ({ color = "#1f1f1f", size = 20 }) => (
    <SvgIcon
      viewBox="0 -960 960 960"
      sx={{
        fontSize: size,
        color,
      }}
    >
      <path d="M600-120v-120H440v-400h-80v120H80v-320h280v120h240v-120h280v320H600v-120h-80v320h80v-120h280v320H600ZM160-760v160-160Zm520 400v160-160Zm0-400v160-160Zm0 160h120v-160H680v160Zm0 400h120v-160H680v160ZM160-600h120v-160H160v160Z" />
    </SvgIcon>
  );
  const navigate = useNavigate();
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const customerContext = React.useContext(CustomerContext);
  const { setCurrentCustomer } = customerContext;
  const [alertMessage, setAlertMessage] = React.useState<string | JSX.Element>("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alert, setAlert] = React.useState("");
  const [showAlertMessage, setShowAlertMessage] = React.useState(false);
  const setDisplayFilter = () => {
    props.displayFilter();
  };

  const showCusotmerForm = () => {
    setCurrentCustomer && setCurrentCustomer(null);
    navigate("/customer");
  };

  const displayClientFiling = () => {
    props.displayClientFiling();
  };

  const displayAddClientFiling = () => {
    props.displayAddClientFiling();
  };

  const editClient = () => {
    props.editClient();
  };

  const deleteClient = () => {
    closeAlert();
    props.deleteClient();
  };

  const deleteClientPopup = () => {
    let usernameForComments = sessionStorage.getItem("usernameForComments");
    console.log("usernameForComments", usernameForComments, props.selectedClients);
    // props.deleteClient();
    if (props.selectedClients?.customerName) {
      setAlertMessage(
        <Typography>
          Are you sure you want to delete <strong>{props.selectedClients?.customerName}</strong>?
        </Typography>
      );
      setShowAlert(true);
    } else {
      setAlert("Please Select a Client Record");
      setShowAlertMessage(true);
    }
  };

  const displayComments = () => {
    props.displayComments();
  };

  const displayClientCategories = () => {
    props.displayClientCategories();
  };

  const displayHistory = () => {
    props.displayHistory();
  };

  const closeAlert = () => {
    setShowAlert(() => false);
  };
  const closeAlert1 = () => {
    setShowAlertMessage(() => false);
  };
  React.useEffect(() => {
    console.log("props.postaward", props.postAward, props.isLoading, props.selectedClients);

  }, [])

  return (
    <React.Fragment>
      <CustomDialog
        header="DELETE CLIENT"
        visible={showAlert}
        onHide={() => closeAlert()}
        onConfirm={() => deleteClient()}
      >
        {alertMessage}
      </CustomDialog>
      <CustomDialog
        header="Info"
        visible={showAlertMessage}
        onHide={() => closeAlert1()}
      >
        {alert}
      </CustomDialog>

      <Box sx={{
        width: "100%",
        bgcolor: "white",
        borderRadius: "50px !important",
        padding: "16px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px"
      }}>
        <nav aria-label="main mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton disabled={props.isLoading} sx={{ justifyContent: "center", padding: "8px" }}>
                <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                  <GoogleMaterialIcon name="filter_list" size={24} color={primaryColor} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Add Client">
                <ListItemButton
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "addClient",
                      props.selectedClients
                    ) || props.isLoading
                  }
                  onClick={showCusotmerForm}
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="person_add" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
          </List>
        </nav>
        <Divider sx={{ width: "80%", bgcolor: primaryColor }} />
        <nav aria-label="secondary mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Deferred Filings">
                <ListItemButton
                  onClick={displayAddClientFiling}
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "addFiling",
                      props.selectedClients?.customerId
                    ) || props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="post_add" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            {/* <ListItem disablePadding>
              <ListItemButton
                disabled={
                  !usePermission("ClientProfile", "viewFiling") ||
                  props.isLoading
                }
                onClick={displayClientFiling}
              >
                <ToolTip title='View Filings'>
                  <ViewListIcon />
                </ToolTip>
              </ListItemButton>
            </ListItem> */}
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="TrackNow Client Filings">
                <ListItemButton
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "tracknowClientFiling",
                    ) || props.isLoading
                  }
                  onClick={displayClientFiling}
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="view_list" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Comments">
                <ListItemButton
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "comments",
                      props.selectedClients?.customerId
                    ) || props.isLoading
                  }
                  onClick={displayComments}
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="comment" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>

            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Edit Client Profile">
                <ListItemButton
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "editClient",
                      props.selectedClients?.customerId
                    ) || props.isLoading
                  }
                  onClick={editClient}
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="edit" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Delete Client">
                <ListItemButton
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "deleteClient",
                      props.selectedClients?.customerId
                    ) || props.isLoading
                  }
                  onClick={deleteClientPopup}
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="delete" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Activity History">
                <ListItemButton
                  onClick={displayHistory}
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "deleteClient",
                      props.selectedClients?.customerId
                    ) || props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="history" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Business Categories">
                <ListItemButton
                  disabled={
                    !usePermission(
                      "ClientProfile",
                      "viewBusinessClient",
                      props.selectedClients?.customerId
                    ) || props.isLoading || props.postAward
                  }
                  onClick={displayClientCategories}
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name="domain_add" size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
          </List>
        </nav>
      </Box>
    </React.Fragment>
  );
}
